import App from "../../../../vendor_core/core/src/App";
import Utils from "../../../../vendor_core/core/src/utils/Utils";
import SpinDataParser from "../../../../vendor_core/src/server/parsers/SpinDataParser";
import SymbolMap from "../../../../vendor_core/core/src/utils/SymbolMap";
import * as resp from "./resp2.json";
import ISpinData from '../../../../vendor_core/core/src/server/data/ISpinData';

export default class CRCSpinDataParser extends SpinDataParser {
    private zeroBase: number = 0;

    validateData(data: any): boolean {
        return (data.generations || data.refresh) && data.stats;
    }

    processData(data: any): any[] {
        let results = [];

        // data = resp

        if (data.refresh) {
            data = data.refresh
        }

        const result = this.parseMainSpin(data);
        results.push(result);

        data.freespins?.forEach((spinData, index) => {
            const parsed = this.parseMainSpin(spinData, true, index);
            // Parse free spin retrigger
            if (data?.freespins[index + 1]?.totalFs && parsed.totalFreeSpins !== data.freespins[index + 1].totalFs) {
                parsed.freespinsWon = data.freespins[index + 1].totalFs - parsed.totalFreeSpins;
            }
            results.push(parsed);
        });

        return results;
    }

    parseMainSpin(data, fs = false, fsIdx = 0) {
        const generationsData = this.parseGenerationsSymbolsData(
            Utils.deepClone(data.generations)
        );

        const cascadesData = this.parseCascadeSpins(generationsData, data);

        return {
            isFree: fs,
            winsMultiplier: data.multiplier,
            winsWildMultiplier: data.semiPersistentMultiplier,
            winAmount: data.spinWin,
            accumulatedWin: data.spinWin + (data.runningTotal || 0),
            tempWinAmount: 0,
            balance: data.stats ? data.stats.b : undefined,
            generations: this.parseGenerationsCoinsCoordinates(data.generations),
            respin: data.respin,
            freespins: data.freespins,
            freespinsWon: fs ? data.extraFs || 0 : data.freespins?.length ? 15 : 0,
            cascades: cascadesData,
            cascadeIndex: 0,
            freespinsNum: data?.freespins?.length > 0 && fs === false ? 15 : data.totalFs - fsIdx - 1,
            totalFreeSpins: data?.freespins?.length > 0 && fs === false ? 15 : data.totalFs,
        };
    }


    parseGenerationsSymbolsData(generationData): any[] {
        if (generationData) {
            let i: number;
            const genDataLen = generationData.length;
            for (i = 0; i < genDataLen; i++) {
                generationData[i].index = i;
                generationData[i].ended = i === genDataLen - 1;
                generationData[i].removedSymbols = Utils.deepClone(
                    generationData[i].destroyedXPositions
                );
                generationData[i].symbols = SymbolMap.parseSymbols(
                    generationData[i].symbols
                );
                generationData[i].originalSymbols = SymbolMap.parseSymbols(
                    generationData[i].symbols
                );
                generationData[i].generationWin = this.calculateGenWin(
                    generationData[i].winnings
                );
                generationData[i].transformation = generationData[i].transform;
            }
            return generationData;
        }
    }

    calculateGenWin(winData) {
        let winning = 0;
        if (winData?.length > 0) {
            for (let i = 0; i < winData.length; i++) {
                if (winData[i][0] != "freespins") {
                    winning += winData[i].amount;
                }
            }
        }
        return winning;
    }

    parseCascadeSpins(cascadeSpins: any, data): any[] {
        if (!cascadeSpins) {
            return [];
        }

        let cascades = [];

        cascadeSpins.forEach((cascade, index) => {
            let parsedCascade = this.parseCascadeObject(cascade, data);
            cascades.push(parsedCascade);
        });

        return cascades;
    }

    parseCascadeObject(cascade, data): any {
        let winsData = cascade?.winnings?.length > 0 ? this.parseWinData(cascade.winnings) : [];
        let cascadeWinOffsets = this.calculateWinOffset(
            Utils.deepClone(winsData),
            Utils.deepClone(cascade.symbols)
        );
        let cascadeExplodesOffsets = this.calculateRespinsOffset(
            Utils.deepClone(cascade.respin)
        );

        // Weird hack to solve the full drop when there's an explosion
        // We need to fill in the explosions array so the reel behaviour decides to stack, not fully drop
        // So we set an array with one impossible position - 999
        if (cascadeExplodesOffsets.length === 0 && cascade.explosions) {
            cascadeExplodesOffsets = [999];
        }

        const reelSetIndex = 0; // There are not reelSetIndex for cascade games. That's why this is hardcoded to 0.
        const symbols = new Map<number, number[][]>();
        symbols.set(reelSetIndex, cascade.symbols);

        const result = {
            winAmount: cascade.tumbleWin,
            currentWin: cascade.tumbleWin,
            accumulatedWin:
                (data.runningTotal || 0) +
                cascade.runningTumbleWin +
                cascade.tumbleWin,
            tempWinAmount: cascade.runningTumbleWin + cascade.tumbleWin,
            winsData,
            multiplier: cascade.multiplier,
            cascadeWinOffsets: cascadeWinOffsets,
            cascadeExplodesOffsets,
            reelStopSymbols: symbols, // first gen
            reelFinalSymbols: symbols, // last gen
            respin: cascade.respin,
            explosions: cascade.explosions,
        };

        return result;
    }

    public parseWinData(winData) {
        const winsData = [];
        for (let i = 0; i < winData.length; i++) {

            const data = winData[i];

            const type = data[0];
            const amount = data[2];
            const coords = data[3];
            const symbol = data[4];
            const multiplier = data[5];

            winsData.push({
                type,
                isWay: false,
                normalLineWin: true,
                creditsWon: amount,
                winSymId: App.config.symbolResponseMap[symbol],
                lineId: undefined, // winData[i][1], // starts from 1
                multiplier,
                coordinates: this.parseWinCoordinates(coords),
                winReels: this.resolveWinCoords(true, coords),
                winSymbols: this.resolveWinCoords(false, coords),
            });
        }
        return winsData;
    }

    parseWinCoordinates(coor: { x: number; y: number }[]) {
        //  return coor.map((obj) => {obj.x += this.zeroBase, obj.y += this.zeroBase})
        // return coor.map(({x, y}) => {x += this.zeroBase, y += this.zeroBase});

        let newArr = [];
        coor.forEach((obj) => {
            let newObj = {};
            newObj["x"] = obj.x += this.zeroBase;
            newObj["y"] = obj.y += this.zeroBase;
            newArr.push(newObj);
        });

        return newArr;
    }

    resolveWinCoords(reels, data: { x: number; y: number }[]) {
        let coord = reels ? "x" : "y";
        let result = [];
        for (let i = 0; i < data.length; i++) {
            result.push(data[i][coord] - 1); // -1 because relax counts from 1
        }
        return result;
    }

    calculateWinOffset(winnings, symbols: number[][]): any {
        if (winnings && winnings[0]) {
            let winOffset = [];
            winnings.forEach((winnig) => {
                winnig.winSymbols.forEach((row, index) => {
                    let reel = winnig.winReels[index];
                    let pos = row * App.config.numReels + reel;
                    if (!winOffset.includes(pos) && symbols[reel][row] != 0) {
                        winOffset.push(row * App.config.numReels + reel);
                    }
                });
            });
            return winOffset;
        } else {
            return [];
        }
    }

    calculateRespinsOffset(respins: any[]): number[] {
        if (respins && respins.length > 0) {
            let respinOffsets = [];
            respins.forEach((r) => {
                let pos = r.y * (App.config.numVisibleLines + 1) + r.x;
                if (r.symbol === " " && !respinOffsets.includes(pos)) {
                    respinOffsets.push(pos);
                }
            });
            return respinOffsets;
        } else {
            return [];
        }
    }

    /////////////////// Coin Crush Game specific ///////////////////
    parseGenerationsCoinsCoordinates(generationData): any {

        let result = generationData;

        if (generationData) {
            const cloneGenerations = Utils.deepClone(generationData);
            cloneGenerations?.forEach((g, gi) => {
                if (g?.newCoins) {
                    g.newCoins.forEach((n, i) => {
                        g.newCoins[i].coordinate = {
                            x: n.coordinate.x - 1,
                            y: n.coordinate.y - 1
                        }
                    })
                }
                if (g?.currentCoins) {
                    g.currentCoins.forEach((n, i) => {
                        g.currentCoins[i].coordinate = {
                            x: n.coordinate.x - 1,
                            y: n.coordinate.y - 1
                        }
                    })
                }
                if (g?.rainCoins) {
                    g.rainCoins.forEach((n, i) => {
                        g.rainCoins[i].coordinate = {
                            x: n.coordinate.x - 1,
                            y: n.coordinate.y - 1
                        }
                    })
                }
            })

            result = cloneGenerations;
        }

        return result
    }
    /////////////////// Coin Crush Game specific ///////////////////
}
